<template>
  <div style="display:inline">
    <el-select v-model="val" placeholder="请选择" @change="change" :disabled="disabled">
      <el-option v-if="showAll" label="全部" value></el-option>
      <el-option v-for="item in options" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "static-selector",
  props: {
    type: {
      type: String
    },
    value: {
      type: [String, Number],
      default: ""
    },
    showAll: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      val: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.val = val;
      }
    }
  },
  computed: {
    ...mapState(["systemConfig"])
  },
  mounted() {
    this.options = this.adapter(this.systemConfig[this.type]);
    this.$watch("value", val => {
      if (val || val === 0) {
        this.val = val;
        this.clear();
      }
    });
  },
  methods: {
    change() {
      this.$emit("update:value", this.val);
    },
    adapter(options) {
      let tmp = [];
      if (this.type === "floor" || this.type === "price") {
        tmp = options.map(el => {
          return { code: el, name: el };
        });
        return tmp;
      }
      return options;
    },
    clear() {
      if (!this.options.find(el => el.code === this.val)) {
        this.val = "";
        this.change();
      }
    },
    reset() {
      this.val = "";
      this.$emit("update:value", "");
    }
  }
};
</script>
<style>
</style>